/*
 * @Author: wangxiaoheng
 * @Date: 2023-01-19 11:50:50
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-01-19 11:54:30
 * @FilePath: \megagame_web\src\utils\yearOld.js
 * @Description: 
 * 
 * 
 */
//获取当月的天数
function getDaysOfMonth(dateStr){   
    var date = new Date(dateStr);
    var year = date.getFullYear();
    var mouth = date.getMonth() + 1;
    var day = 0;
    if(mouth == 2){
      day= isLeapYear(year) ? 29 : 28;
    } else if(mouth == 1 || mouth == 3 || mouth == 5 || mouth == 7 || mouth == 8 || mouth == 10 || mouth == 12){
      day= 31;
    } else{
      day= 30;
    }
    return day;
}
 
//判断是否为闰年
function isLeapYear(year){
  return (year%4==0 && year%100!=0)||(year%400==0);
}
// 判断年龄
export function getGrowAge(birthday){
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
     
    var myDate = new Date(birthday);
    var myYear = myDate.getFullYear();
    var myMonth = myDate.getMonth() + 1;
    var myDay = myDate.getDate();
    var myHour = myDate.getHours();
    var myMinute = myDate.getMinutes();
    var mySecond = myDate.getSeconds();
     
    var gapSecond = second - mySecond;
    if(gapSecond < 0)
    {
        minute -= 1;
        gapSecond = 60 - mySecond + second;
    }
    var gapMinute = minute - myMinute;
    if(gapMinute < 0){
      hour -= 1;
      gapMinute = 60 - myMinute + minute;
    }
    var gapHour = hour - myHour;
    if(gapHour < 0){
        day -= 1;
        gapHour = 24 - myHour + hour;
    }
    var gapDay = day - myDay;
    if(gapDay < 0){
        month -= 1;
        gapDay = getDaysOfMonth(birthday) - myDay + day;
    }
    var gapMonth = month - myMonth;
    if(gapMonth < 0){
        year -= 1;
        gapMonth = 12 - myMonth + month;
    }
    var gapYear = year - myYear;
    if(gapYear < 0){
        gapYear = 0;
    }
    // var dateStr = gapYear+"岁 " + 
    //               (gapMonth<10? ("0"+gapMonth): gapMonth)+"月 " + 
    //               (gapDay<10? ("0"+gapDay): gapDay)+"天 " + 
    //               (gapHour<10? ("0"+gapHour): gapHour)+"时 " + 
    //               (gapMinute<10? ("0"+gapMinute): gapMinute)+"分 " + 
    //               (gapSecond<10? ("0"+gapSecond): gapSecond)+"秒";
    return {
      gapYear:gapYear,
      gapMonth:gapMonth,
      gapDay:gapDay,
      gapHour:gapHour,
      gapMinute:gapMinute,
      gapSecond:gapSecond,
    };
}